type D3Selection<T extends d3.BaseType> = d3.Selection<T, unknown, HTMLElement, any>;

export class GraphLegendV2 {
  private readonly itemSpacing = 22;
  private readonly bgPadding = 12;
  private group: D3Selection<SVGGElement>;
  private bg: D3Selection<SVGRectElement>;

  constructor(private svg: D3Selection<SVGSVGElement>, private data: any[]) {
    this.group = svg.append('g');
    this.bg = this.group.append('rect');
    this.renderItems();
    requestAnimationFrame(() => this.renderBg()); // Ensure correct dimensions
  }

  setPosition(elem) {
    const graphElement = elem;
    if (!graphElement) return;
    const height = graphElement.nativeElement.clientHeight;
    const groupHeight = this.group.node().getBBox().height + this.itemSpacing;

    this.group.attr('transform', `translate(12, ${height - groupHeight})`);
  }

  private renderItems() {
    const items = this.group
      .selectAll('.legend')
      .data([...this.data].reverse()) // Avoid modifying original data
      .enter()
      .append('g')
      .attr('class', 'legend')
      .attr('transform', (_, i) => `translate(0, ${i * this.itemSpacing})`); // Use index instead of itemEdge

    items
      .append('rect')
      .attr('x', 16)
      .attr('width', 16)
      .attr('height', 16)
      .style('opacity', 1)
      .style('fill', (d) => d.color);

    items
      .append('text')
      .attr('x', 36)
      .attr('y', 8)
      .attr('dy', '.35em')
      .style('text-anchor', 'start')
      .text((d) => d.label);
  }

  private renderBg() {
    requestAnimationFrame(() => {
      const groupNode = this.group.node();
      if (!groupNode) return; // Ensure the element exists

      const { x, y, width, height } = groupNode.getBBox();
      this.bg
        .attr('x', x - this.bgPadding)
        .attr('y', y - this.bgPadding)
        .attr('width', width + this.bgPadding * 2)
        .attr('height', height + this.bgPadding * 2)
        .attr('rx', 8)
        .style('fill', '#ffffff')
        .style('opacity', 0.7);

      this.group
        .on('mouseover', () => this.bg.style('opacity', 1))
        .on('mouseout', () => this.bg.style('opacity', 0.7));
    });
  }
}
